$(function(){

    // handle observer
    if( 'IntersectionObserver' in window ) {


        // observer check
        let isObserving = false;

        // get elements
        const elements = document.querySelectorAll(":not(.modal) .animateOnView");

        // set up observer
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                let target = entry.target;

                // if not observed and in viewport
                if ( !target.classList.contains('animationDone') && entry.isIntersecting )
                {
                    // get animation class and delay
                    let animationClass = target.dataset.animate;
                    let animationDelay = target.dataset.animationDelay ? parseFloat(target.dataset.animationDelay) * 1000 : 0;

                    // animate element
                    setTimeout(() => {
                        target.classList.add('animationDone', 'animate__animated', animationClass);
                    }, animationDelay); 
                    
                    // stop observing
                    observer.unobserve(target);
                }
            });
        });
        
        function startObserver(){
            if ( !isObserving )
            {
                // observe elements
                elements.forEach(element => {
                    observer.observe(element);
                });

                isObserving = true;
            }
        }

        function destroyObserver(){
            if ( isObserving )
            {
                // destroy observer
                observer.disconnect();

                isObserving = false;
            }
        }


        // observer init
        if ( $(window).width() > 991 ){
            startObserver();
        }
    
        $(window).on('resize', function(){
            if ( $(window).width() > 991 ){
                startObserver();
            }
            else
            {
                destroyObserver();
            }
        });
    }
    else
    {
        // observer not supported
        $('.animateOnView').addClass('animationDone');
    }
});